import { ALL_BUT_PRODUCTION, ALL_ENV, type EnvType } from '../../infra/environment'

/**
 * @deprecated Use https://github.com/loadsmart/carrier-web/wiki/Remote-Configs instead
 */
export type FeatureFlagType = {
  [key in featureFlag]?: {
    description: string
    env: EnvType[]
  }
}

/**
 * @deprecated Use https://github.com/loadsmart/carrier-web/wiki/Remote-Configs instead
 */
export enum featureFlag {
  rfpAccessorials = 'rfp-accessorials',
  shipmentDetails = 'shipment-details',
  rfpBulkPreferredLanesAddExtraLanes = 'rfp-bulk-preferred-lanes-add-extra-lane',
  tenderPage = 'tenderPage',
  revokeIntegration = 'revoke-integration',
}

/**
 * @deprecated Use https://github.com/loadsmart/carrier-web/wiki/Remote-Configs instead
 */
export const featureFlags: FeatureFlagType = {
  [featureFlag.rfpAccessorials]: {
    description: 'RFP accessorials tab',
    env: ALL_ENV,
  },
  [featureFlag.shipmentDetails]: {
    description: 'Agnostic Shipment Details page',
    env: ALL_ENV,
  },
  [featureFlag.rfpBulkPreferredLanesAddExtraLanes]: {
    description: 'RFP Bulk Preferred Lanes, Add Extra Lane flow',
    env: ALL_BUT_PRODUCTION,
  },
  [featureFlag.tenderPage]: {
    description: 'Tender page',
    env: ALL_ENV,
  },
  [featureFlag.revokeIntegration]: {
    description: 'Allow users to revoke integrations from Account Carrier Page',
    env: ALL_BUT_PRODUCTION,
  },
}
